package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY2
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

val grgreen = CssStyle.base {
    Modifier
        .color(Color.rgb(59, 107, 66))
}

val insertedFieldTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Times New Roman")
        .color(Colors.Black)
        .margin(0.px)
        .padding(0.px)
}

/* Table styles */
val pdfTableColumnStyle = CssStyle.base {
    Modifier
        .padding(leftRight = 4.px)
        .textAlign(TextAlign.Center)
        .verticalAlign(VerticalAlign.Top)
        .overflowWrap(OverflowWrap.Anywhere)
        .border(1.px, LineStyle.Solid, Colors.Black)
}

val pdfHeaderBackground = CssStyle.base {
    Modifier
        .backgroundColor(Colors.LightGray)
}

val pdfTableHeaderStyle = CssStyle.base {
    Modifier
        .fontWeight(FontWeight.Bold)
        .fontSize(14.px)
}

val pdfTableTextStyle = CssStyle.base {
    Modifier
        .fontSize(14.px)
        .padding(topBottom = 4.px, leftRight = 0.px)
        .margin(0.px)
}

val overlayTextStyle = CssStyle.base {
    Modifier
        .position(Position.Relative)
        .zIndex(2)
        .height(100.percent)
        .fontFamily("Times New Roman")
}

val LogoStyle = CssStyle.base {
    Modifier
        .width(200.px)
        .margin(top = 30.px)
}

val pageTitleStyle = CssStyle.base {
    Modifier
        .width(200.px)
        .margin(top = 250.px, right = 80.px)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .alignItems(AlignItems.End)
        .letterSpacing(3.px)
}

val pageFooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(Theme.MediumGreen.rgb)
        .fillMaxWidth()
        .height(20.px)
}

val sectionTitleGradiantStyle = CssStyle.base {
    Modifier
        .color(Colors.White)
        .backgroundImage(
            linearGradient(LinearGradient.Direction.ToRight) {
                add(Color.rgb(0x376741))
                add(Color.rgb(0x3e7145))
                add(Color.rgb(0x457b49))
                add(Color.rgb(0x4d864c))
                add(Color.rgb(0x56904f))
            }
        )
        .padding(left = 60.px, top = 6.px, bottom = 8.px)
        .margin(left = -1.px)
        .position(Position.Relative)
        //I guess isn't supported?
        //.boxShadow(BoxShadow.of(0.px,3.px,5.px, color = Color.rgba(0,0,0,50)))
        .zIndex(10)
}

val smallSectionTitleGradiantStyle = CssStyle.base {
    Modifier
        .color(Colors.White)
        .padding(left = 58.px, top = 6.px, bottom = 6.px)
        .margin(left = -1.px)
        //I guess isn't supported?
        //.boxShadow(BoxShadow.of(0.px,3.px,5.px, color = Color.rgba(0,0,0,50)))
}

/* SUMMARY SECTION STYLES */
val summaryColumnStyle = CssStyle.base {
    Modifier
        .fillMaxSize()
        .gap(16.px)
        .padding(left = 55.px, top = 6.px)
        //.boxShadow(BoxShadow.of(5.px,0.px,5.px, color = Color.rgba(0,0,0,50)))
}

/* CASH FLOW SECTION STYLES */
val greyBackStyle = CssStyle.base {
    Modifier
        .backgroundColor(Color.rgb(240, 240, 240))
        .border(1.px, LineStyle.Solid, Colors.Black)
}

val pdfLabelCellStyle = CssStyle.base {
    Modifier
        .fontFamily(FONT_FAMILY2)
        .fontSize(10.px)
        .width(90.px)
        .textAlign(TextAlign.Start)
}

val pdfCellStyle = CssStyle.base {
    Modifier
        .fontFamily(FONT_FAMILY2)
        .fontSize(10.px)
        .textAlign(TextAlign.End)
        .width(60.px)
        .borderCollapse(BorderCollapse.Separate)
}

val tableBoxPaddingStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Block)
        .border(1.px, LineStyle.Solid, Colors.LightGray)
        .padding(2.px)
        .margin(bottom = 0.px)
}

/* SAVINGS ANALYSIS STYLES */
val savingsBubbleStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .width(200.px)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
        //use top and left to move
}

val savingsBubbleTextStyle = CssStyle.base {
    Modifier
        .color(Colors.White)
        .fontFamily(FONT_FAMILY2)
        .fontWeight(FontWeight.Bolder)
        .margin(0.px)
        .padding(0.px)
}

/* ENVIRONMENTAL IMPACT STYLES */
val envImpactBubbleStyle =  CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .width(200.px)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
        //use top and left to move
}

val envImpactTextStyle = CssStyle.base {
    Modifier
        .color(Colors.White)
        .fontFamily(FONT_FAMILY2)
        .fontWeight(FontWeight.Bolder)
        .margin(0.px)
        .padding(0.px)
}

/*  DELIVERABLES INPUT TEXT STYLE  */
val deliveryInputStyle = CssStyle.base {
    Modifier
        .outline(width = 0.px,
            style = LineStyle.None,
            color = Colors.Transparent
        )
        .backgroundColor(Colors.White)
        .width(200.px)
}

val rowStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Row)
            .alignItems(AlignItems.Stretch)
            .fillMaxWidth()
            .border(1.px, LineStyle.Solid, Colors.Black)
    }
    hover {
        Modifier
            .backgroundColor(Colors.LightGray)
    }
}

val columnStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .border(1.px, LineStyle.Solid, Colors.Black)
        .overflowWrap(OverflowWrap.Anywhere)

}

val columnParagraphStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .textAlign(TextAlign.Center)
}
